import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import globalCss from '../../../../scss/global.scss'
import { updateVariableModifiers, updateVariableInstance, changeModifierOrder, changeInstanceOrder } from '../../../actions/actions'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { generateVariableKey } from '../../../utils'

class ModifiersEditor extends Component {
  constructor ({ modifiers, instanceModifiers }) {
    super()
    this.state = {
      modifiers: modifiers || [],
      instanceModifiers: instanceModifiers || []
    }
  }

  componentWillReceiveProps (nextProps) {
    const { modifiers, instanceModifiers, isInstance } = nextProps
    if (isInstance && instanceModifiers) {
      this.setState({
        instanceModifiers
      })
    } else if (modifiers) {
      this.setState({
        modifiers
      })
    }
  }

    handleAddModifier = () => {
      const { isInstance } = this.props
      const modifierType = isInstance ? 'instanceModifiers' : 'modifiers'
      const orderKey = generateVariableKey()
      this.setState(prevState => {
        return {
          [modifierType]: [...prevState[modifierType], { name: '', orderKey }]
        }
      })
    }

    handleDeleteModifier = index => {
      const { modifiers, instanceModifiers } = this.state
      const { isInstance } = this.props
      const modifiersToFilter = isInstance ? instanceModifiers : modifiers
      const modifierType = isInstance ? 'instanceModifiers' : 'modifiers'
      const filteredModifiers = modifiersToFilter.filter((modifier, i) => i !== index)
      this.setState({
        [modifierType]: filteredModifiers
      })
      this.updateVariable(filteredModifiers)
    }

    handleUpdate = (target, index) => {
      const { isInstance } = this.props
      const modifierType = isInstance ? 'instanceModifiers' : 'modifiers'
      const updatedModifiers = [...this.state[modifierType]]
      updatedModifiers[index] = { ...updatedModifiers[index], [target.name]: target.value, args: [] }
      this.setState({
        [modifierType]: updatedModifiers
      })
      this.updateVariable(updatedModifiers)
    }

    handleUpdateArgs = (target, index) => {
      const { isInstance } = this.props
      const modifierType = isInstance ? 'instanceModifiers' : 'modifiers'
      const updatedModifiers = [...this.state[modifierType]]
      if (target.name) {
        const updatedArgs = updatedModifiers[index].args ? [...updatedModifiers[index].args] : []
        if (target.name === 'old') updatedArgs[0] = target.value
        else updatedArgs[1] = target.value
        updatedModifiers[index] = { ...updatedModifiers[index], args: [...updatedArgs] }
      } else {
        updatedModifiers[index] = { ...updatedModifiers[index], args: [target.value] }
      }
      this.setState({
        [modifierType]: updatedModifiers
      })
      this.updateVariable(updatedModifiers)
    }

    updateVariable = updatedModifiers => {
      const { variables: { editing, instance }, dispatch, isInstance } = this.props
      if (isInstance) {
        dispatch(updateVariableInstance(editing, instance, updatedModifiers))
      } else {
        dispatch(updateVariableModifiers(editing, updatedModifiers))
      }
    }

    handleOnDragEnd = result => {
      const { isInstance } = this.props
      if (isInstance) {
        try {
          const { variables: { editing }, variables: { instance } } = this.props
          const { instanceModifiers } = this.state
          const { destination: { index: newIdx }, source: { index: oldIdx }, draggableId } = result
          const updatedModifier = instanceModifiers.filter(modifier => modifier.orderKey === draggableId)[0]
          this.props.dispatch(changeInstanceOrder(updatedModifier, oldIdx, newIdx, editing, instance))
        } catch (error) {

        }
      } else {
        try {
          const { variables: { editing } } = this.props
          const { modifiers } = this.state
          const { destination: { index: newIdx }, source: { index: oldIdx }, draggableId } = result
          const updatedModifier = modifiers.filter(modifier => modifier.orderKey === draggableId)[0]
          this.props.dispatch(changeModifierOrder(updatedModifier, oldIdx, newIdx, editing))
        } catch (error) {

        }
      }
    }

    generateVariableOptions = () => {
      const options = [<option value='' key='_EMPTY_OPTION_'>Select Variable...</option>]
      const { item, variables } = this.props
      for (const key of item.variableOrder) {
        const variable = item.variables[key]
        if (key !== variables.editing && variable.macro !== 'choiceFromDataSource') {
          options.push(
            <option value={key} key={key}>{variable.name}</option>
          )
        }
      }
      return options
    }

    toggleVariable = (modifierIndex, type) => {
      const { isInstance } = this.props
      const modifierType = isInstance ? 'instanceModifiers' : 'modifiers'
      const modifiers = [ ...this.state[modifierType] ]
      const modifier = modifiers[modifierIndex]
      let valueIndex = 0
      let isVariableIndex = 2
      if (type === 'replacement') {
        valueIndex = 1
        isVariableIndex = 3
      }
      modifier.args[isVariableIndex] = !modifier.args[isVariableIndex]
      modifier.args[valueIndex] = ''
      this.setState({
        [modifierType]: modifiers
      })
    }

    render () {
      const { modifiers, instanceModifiers } = this.state
      const { app: { primaryColor }, isInstance } = this.props

      const variableOptions = this.generateVariableOptions()

      let modifiersToMap = modifiers
      let modifierType = 'Base'
      if (isInstance) {
        modifiersToMap = instanceModifiers
        modifierType = 'Instance'
      }

      const modifierList = modifiersToMap.map((modifier, i) => {
        let roundMethod
        if (modifier.name === 'round') {
          roundMethod = (
            <div className={css.modifierBlock}>
              <label>Method</label>
              <div className={css.backer}>
                <select className={css.select} value={modifier.args ? modifier.args[0] : ''} onChange={evt => this.handleUpdateArgs(evt.target, i)}>
                  <option value=''>Select a rounding option...</option>
                  <optgroup label='Decimal' key='Decimal'>
                    <option value={0.001} key='Thousandth'>Thousandth</option>
                    <option value={0.01} key='Hundredth'>Hundredth</option>
                    <option value={0.1} key='Tenth'>Tenth</option>
                  </optgroup>
                  <optgroup label='Integer' key='Integer'>
                    <option value={1} key='Whole'>Whole</option>
                    <option value={5} key='Five'>Five</option>
                    <option value={10} key='Ten'>Ten</option>
                    <option value={50} key='Fifty'>Fifty</option>
                    <option value={100} key='Hundred'>Hundred</option>
                    <option value={500} key='Five Hundred'>Five Hundred</option>
                    <option value={1000} key='Thousand'>Thousand</option>
                    <option value={1000000} key='Million'>Million</option>
                  </optgroup>
                </select>
              </div>
            </div>
          )
        }

        let replaceMethod
        if (modifier.name === 'replace') {
          let existingValueButtonText = 'variable'
          let existingValueInput = (
            <input
              type='text'
              name='old'
              defaultValue={modifier.args ? modifier.args[0] : ''}
              className={css.option}
              onBlur={evt => this.handleUpdateArgs(evt.target, i)}
              placeholder="Enter Value..."
            />
          )

          if (modifier.args[2]) {
            existingValueButtonText = 'value'
            existingValueInput = (
              <div className={css.backer}>
                <select name='old' className={css.select} value={modifier.args[0] ? modifier.args[0] : ''} onChange={evt => this.handleUpdateArgs(evt.target, i)}>
                  {variableOptions}
                </select>
              </div>
            )
          }

          let replacementValueButtonText = 'variable'
          let replacementValueInput = (
            <input
              type='text'
              name='new'
              defaultValue={modifier.args ? modifier.args[1] : ''}
              className={css.option}
              onBlur={evt => this.handleUpdateArgs(evt.target, i)}
              placeholder="Enter Value..."
            />
          )

          if (modifier.args[3]) {
            replacementValueButtonText = 'value'
            replacementValueInput = (
              <div className={css.backer}>
                <select name='new' className={css.select} value={modifier.args[1] ? modifier.args[1] : ''} onChange={evt => this.handleUpdateArgs(evt.target, i)}>
                  {variableOptions}
                </select>
              </div>
            )
          }

          replaceMethod = (
            <div className={css.replaceWrapper}>
              <div className={css.replaceBlock}>
                <label style={ { maxHeight: '15px'} }>
                  Existing Value
                  <button className={css.switchBtn} onClick={() => this.toggleVariable(i, 'existing')}>Use a {existingValueButtonText}</button>
                </label>
                {existingValueInput}
              </div>
              <div className={`${css.replaceBlock} ${css.extraMargin}`}>
                <label style={ { maxHeight: '15px'} }>
                  Replacement Value
                  <button className={css.switchBtn} onClick={() => this.toggleVariable(i, 'replacement')}>Use a {replacementValueButtonText}</button>
                </label>
                {replacementValueInput}
              </div>
            </div>
          )
        }

        return (
          <Draggable draggableId={modifier.orderKey} index={i} key={`${i}_chunk`}>
            {(provided, snapshot) => {
              return (
                <div
                  className={css.modifierContainer}
                  key={`${i}_modifier`}
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                >
                  <span className={css.handle} {...provided.dragHandleProps}>
                    <div className={css.bars} />
                  </span>
                  <div className={css.modifierBlock}>
                    <label>Modifier</label>
                    <div className={css.backer}>
                      <select className={css.select} value={modifier.name ? modifier.name : ''} name='name' onChange={evt => this.handleUpdate(evt.target, i)}>
                        <option value=''>Select Modifier</option>
                        <optgroup label="Text Modifiers">
                          <option value='upperCase'>Upper Case</option>
                          <option value='lowerCase'>Lower Case</option>
                          <option value='titleCase'>Title Case</option>
                          <option value='replace'>Replace</option>
                        </optgroup>
                        <optgroup label="Number Modifiers">
                          <option value='ceil'>Ceiling</option>
                          <option value='floor'>Floor</option>
                          <option value='round'>Round</option>
                          <option value='binary'>Binary</option>
                          <option value='commaSeparate'>Comma Separate</option>
                          <option value='toEnglish'>To English</option>
                        </optgroup>
                      </select>
                    </div>
                  </div>
                  <span className={css.delete} onClick={() => this.handleDeleteModifier(i)} style={{ color: primaryColor }}>Delete</span>
                  {roundMethod}
                  {replaceMethod}

                </div>
              )
            }}
          </Draggable>
        )
      })
      return (
        <DragDropContext onDragEnd={this.handleOnDragEnd}>
          <Droppable droppableId='modifiers' type='VARIABLE'>
            {(provided, snapshot) => (
              <div className={css.container} ref={provided.innerRef} {...provided.droppableProps}>
                <label>{modifierType} Modifiers</label>
                {modifierList}
                <button
                  className={css.add}
                  type='button'
                  onClick={this.handleAddModifier}
                  style={{ background: primaryColor }}
                >
                  <i className={globalCss.iconPlus} />
                  &nbsp; Add {modifierType} Modifier
                </button>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )
    }
}

const mapStateToProps = ({ app, item, variables }) => {
  return {
    app,
    item,
    variables
  }
}

export default connect(mapStateToProps)(ModifiersEditor)



// WEBPACK FOOTER //
// /app/js/components/EditVariable/ModifiersEditor/index.js